// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatRowMenu-moduleitem__jOrAW";
var _2 = "GretaAIChatRowMenu-moduleitemIcon__uHMVP IconNG-moduleIcon__AbXiV";
var _3 = "GretaAIChatRowMenu-moduleitemLabel__axgwl";
var _4 = "GretaAIChatRowMenu-modulemenu__oGYFA SelectDropdown-moduleSelectDropdown__s9tE2";
export { _1 as "item", _2 as "itemIcon", _3 as "itemLabel", _4 as "menu" }
